module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid-x', {
    attrs: {
      "col": _vm.columns,
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [(_vm.showUploader === 'hero') ? _c('div', [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.title),
      expression: "item.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Hero Text"
    },
    domProps: {
      "value": (_vm.item.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "title", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("Image Preview")]), _vm._v(" "), (_vm.showUploader === 'hero') ? _c('div', {
    staticClass: "hero-preview"
  }, [_c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.switchHero('mobile')
      }
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.switchHero('desktop')
      }
    }
  }, [_vm._v("Desktop")])]), _vm._v(" "), _c('div', {
    staticClass: "desktop-preview"
  }, [_c('div', {
    ref: "hero",
    staticClass: "hero-image desktop"
  }, [_c('img', {
    staticClass: "object-fit",
    attrs: {
      "src": _vm.previewImage ? _vm.previewImage : _vm.item.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-text"
  }, [_c('h2', {
    staticClass: "hero-text-title",
    domProps: {
      "innerHTML": _vm._s(_vm.item.title)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hero-author"
  }, [_c('i', [_vm._v("by")]), _vm._v("\n              " + _vm._s(_vm.item.authorName ? _vm.item.authorName : "Boaty McBoatface") + "\n            ")])])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-335d6fd1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/heroPreview.vue
// module id = 645
// module chunks = 1